// extracted by mini-css-extract-plugin
export default {"issueDependenciesList":"DependencyEvent-module__issueDependenciesList--jkHQC","issueDependencyItem":"DependencyEvent-module__issueDependencyItem--YsJF8"};